import React from 'react';
import ReactDOM from 'react-dom/client';
import './CSS/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {console.log('░▒█░▒█░▒█▄░▒█░▀█▀░▒█▀▀█░▒█░▒█░▒█▀▀▀\n░▒█░▒█░▒█▒█▒█░▒█░░▒█░▒█░▒█░▒█░▒█▀▀▀\n░░▀▄▄▀░▒█░░▀█░▄█▄░░▀▀█▄░░▀▄▄▀░▒█▄▄▄\n-----------------------------------\nunique-000.github.com')}
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
